import React from "react";
import { ArrowUpRight } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/8761299/pexels-photo-8761299.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative border-b border-black/10 bg-white"
    >
      <div className="absolute inset-0 bg-grid pointer-events-none opacity-70" />

      <div className="relative mx-auto max-w-7xl px-5 md:px-10 pt-16 md:pt-24 pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="overline mb-6" data-testid="hero-overline">
              Behavioural Training · POSH · NLP
            </div>
            <h1
              data-testid="hero-heading"
              className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-black"
            >
              Train the mind.
              <br />
              Change the
              <span className="inline-block ml-2 md:ml-3 px-2 md:px-3 bg-[color:var(--bts-yellow)] border border-black">
                behaviour
              </span>
              .
            </h1>
            <p
              data-testid="hero-subheading"
              className="mt-6 max-w-xl text-base md:text-lg text-neutral-700 leading-relaxed"
            >
              Corporate and educational training programs by <b>Ruchika Thakkar Singh</b> —
              Certified POSH trainer and NLP practitioner. Virtual and in-person workshops
              built around real behaviour change.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-cta-primary"
                onClick={() => scrollTo("pricing")}
                className="btn-primary"
              >
                Explore workshops <ArrowUpRight size={18} />
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={() => scrollTo("contact")}
                className="btn-secondary"
              >
                Book a discovery call
              </button>
            </div>

            <div className="mt-12 grid grid-cols-2 gap-6 max-w-md">
              <Stat n="15+" label="Years experience" />
              <Stat n="3000+" label="Professionals trained" />
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-[color:var(--bts-yellow)] border border-black hidden md:block" />
              <div className="relative border border-black overflow-hidden hard-shadow bg-white">
                <img
                  src={HERO_IMG}
                  alt="Corporate behavioural training"
                  className="w-full h-[420px] md:h-[520px] object-cover"
                  loading="eager"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black text-white px-5 py-3 flex items-center justify-between">
                  <span className="overline text-white/80">Certified · POSH · NLP</span>
                  <span className="font-display text-sm">since 2013</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="border-t border-b border-black/10 bg-white overflow-hidden">
        <div className="marquee-track py-4 whitespace-nowrap">
          {Array.from({ length: 2 }).flatMap((_, i) =>
            [
              "Behavioural Training",
              "POSH Compliance",
              "Neuro Linguistic Programming",
              "Corporate Workshops",
              "Educational Institutes",
              "Communication",
              "Etiquette",
              "Interview Prep",
            ].map((t, j) => (
              <span
                key={`${i}-${j}`}
                className="font-display text-2xl md:text-3xl text-black flex items-center gap-8"
              >
                {t}
                <span className="w-2 h-2 bg-[color:var(--bts-yellow)] inline-block" />
              </span>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

const Stat = ({ n, label }) => (
  <div>
    <div className="font-display text-3xl md:text-4xl text-black">{n}</div>
    <div className="text-xs text-neutral-500 mt-1 leading-tight">{label}</div>
  </div>
);

export default Hero;
